import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FilterByIndicationPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'filterByIndication',
})
export class FilterByIndicationPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(assets: any[], indicationId: any) {
    if (!assets || typeof indicationId == "undefined" || indicationId == "" || indicationId == null) {
      return assets;
    } else {
      return assets.filter(asset => asset.Indication.some(indication => indication.IndicationId == indicationId))
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filter-by-indication/filter-by-indication.ts